import CopyInfo from './copy-info';

export default CopyInfo;
